import Vue from 'vue'
import VueRouter from 'vue-router'
import { publicPath } from '../../vue.config'
//import { baseUrl } from '../../vue.config'


Vue.use(VueRouter)

  const routes = [
  { path: '*', redirect: '/' },
  { path: '/', name: 'home', component: () => import('@/components/home.vue') },

  { path: '/reserva', name: 'reserva', component: () => import('@/components/reserva.vue') },
  { path: '/hoteles', name: 'hoteles', component: () => import('@/components/hoteles.vue') },
  { path: '/informacion', name: 'informacion', component: () => import('@/components/informacion.vue') },
  { path: '/folletos', name: 'folletos', component: () => import('@/components/folletos.vue') },
  { path: '/contacto', name: 'contacto', component: () => import('@/components/contacto.vue') },

  { path: '/reservas', name: 'reservas', component: () => import('@/components/reservas.vue') },
  { path: '/hotel-info', name: 'hotel-info', component: () => import('@/components/hotel-info.vue') },
  { path: '/info-personal', name: 'info-personal', component: () => import('@/components/info-personal.vue') },
  { path: '/pago-tarjeta', name: 'pago-tarjeta', component: () => import('@/components/pago-tarjeta.vue') },

  { path: '/condiciones-generales', name: 'condiciones-generales', component: () => import('@/components/condiciones-generales.vue') },
  { path: '/politica', name: 'politica', component: () => import('@/components/politica.vue') },
  { path: '/cookies', name: 'cookies', component: () => import('@/components/cookies.vue') },
  { path: '/avisolegal', name: 'avisolegal', component: () => import('@/components/avisolegal.vue') },


]

const router = new VueRouter(
{
  base: publicPath,
  mode: 'history',
  routes,

  scrollBehavior() {
    return {x: 0, y: 0}
  }
})

export default router

